import React, { useMemo } from "react";
import { Globe, Smartphone } from "lucide-react";
import DeviceFrame from "./DeviceFrame";
import EmptyState from "../common/EmptyState";
import { SORT_MODES } from "../../constants/previewConfig";

// Width as currently displayed, i.e. after any rotation.
const displayWidth = (device, orientationByDevice) =>
  orientationByDevice[device.id] ? device.height : device.width;

function sortDevices(devices, sortMode, orientationByDevice) {
  const list = [...devices];
  switch (sortMode) {
    case SORT_MODES.WIDTH:
      return list.sort(
        (a, b) => displayWidth(a, orientationByDevice) - displayWidth(b, orientationByDevice)
      );
    case SORT_MODES.CATEGORY:
      return list.sort((a, b) => a.category.localeCompare(b.category));
    case SORT_MODES.BRAND:
      return list.sort((a, b) => a.brand.localeCompare(b.brand));
    case SORT_MODES.NAME:
      return list.sort((a, b) => a.name.localeCompare(b.name));
    default:
      return list;
  }
}

function PreviewGrid({
  finalUrl,
  devices,
  orientationByDevice,
  globalZoom,
  globalReloadToken,
  layoutMode,
  sortMode,
  onRotate,
  onRemove,
}) {
  const ordered = useMemo(
    () => sortDevices(devices, sortMode, orientationByDevice),
    [devices, sortMode, orientationByDevice]
  );

  if (!finalUrl) {
    return (
      <EmptyState
        icon={Globe}
        title="Enter a URL to start previewing"
        description="Type a website address in the bar above, then select one or more devices from the sidebar."
      />
    );
  }

  if (devices.length === 0) {
    return (
      <EmptyState
        icon={Smartphone}
        title="No devices selected"
        description="Choose phones, tablets, laptops, or desktops from the sidebar to see them here."
      />
    );
  }

  return (
    <div className={`preview-grid preview-grid-${layoutMode}`}>
      {ordered.map((device, index) => (
        <DeviceFrame
          key={device.id}
          index={index}
          device={device}
          url={finalUrl}
          rotated={Boolean(orientationByDevice[device.id])}
          globalZoom={globalZoom}
          globalReloadToken={globalReloadToken}
          onRotate={onRotate}
          onRemove={onRemove}
        />
      ))}
    </div>
  );
}

export default PreviewGrid;
